import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

export const MiniMapControl = ({ kidMode = true }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return undefined;

    const miniMapDiv = L.DomUtil.create('div', kidMode ? 'minimap minimap-kids' : 'minimap');
    miniMapDiv.style.cssText = 'position:absolute;bottom:20px;left:20px;width:166px;height:166px;z-index:1000;overflow:hidden;';

    const sticker = L.DomUtil.create('div', 'minimap-sticker', miniMapDiv);
    sticker.textContent = kidMode ? 'مصر الصغيرة 🧩' : 'خريطة مصغرة';

    const minimapContainer = L.map(miniMapDiv, {
      center: [26.8206, 30.8025],
      zoom: 4,
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      scrollWheelZoom: false
    });

    const tile = kidMode
      ? 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
      : 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png';

    L.tileLayer(tile).addTo(minimapContainer);

    const bounds = map.getBounds();
    const rectangle = L.rectangle(bounds, {
      color: kidMode ? '#fb7185' : '#1e88e5',
      weight: 2,
      fillOpacity: kidMode ? 0.18 : 0.12
    }).addTo(minimapContainer);

    const updateRectangle = () => {
      rectangle.setBounds(map.getBounds());
    };

    map.on('moveend', updateRectangle);
    map.getContainer().appendChild(miniMapDiv);

    return () => {
      map.off('moveend', updateRectangle);
      miniMapDiv.remove();
      minimapContainer.remove();
    };
  }, [kidMode, map]);

  return null;
};
